// Quiz "¿Qué Tiny necesitáis?": avanza pregunta a pregunta (estilo Typeform), cambia la
// foto de la izquierda según la pregunta activa, manda las respuestas a Klaviyo como
// evento (+ suscripción opcional si hay consentimiento) y, al terminar, REDIRIGE a la
// página de creación de plan (bundle) con los productos recomendados ya preseleccionados
// — no se muestra nada en esta página.
//
// Cómo se calcula la recomendación: cada pregunta aporta una letra según la POSICIÓN de la
// opción marcada (1ª opción = A, 2ª = B, 3ª = C...). Uniendo las letras de todas las
// preguntas que de verdad se mostraron (las condicionales que no se llegan a ver no
// aportan letra) se forma una clave, p.ej. "A,B,C,D,A,B". Esa clave se busca en el mapa de
// combinaciones que rellena el equipo desde el editor; si no hay coincidencia, se usan los
// productos de reserva.
//
// Pantalla intermedia al terminar: al validar el paso de email se muestra un overlay con
// una barra de progreso y dos textos ("Creando la mejor receta para tu peque" → "Añadiendo
// productos al carrito") y solo después se redirige. Sin esto el salto al plan es tan
// inmediato que no se entiende qué ha pasado; los textos y los segundos de cada uno son
// ajustes de la sección, y se puede apagar entero con "Mostrar pantalla de carga".
//
// El retardo es el MÍNIMO que se espera, no un tope: la redirección espera a que se haya
// enviado el evento de Klaviyo (como antes, con su propio tope de KLAVIYO_WAIT_MS) Y a que
// haya pasado el tiempo de la pantalla, así que si Klaviyo va lento se alarga la pantalla
// en vez de saltársela.
//
// Cómo se preseleccionan los productos en la página del bundle: se escribe en localStorage
// con la misma clave y formato que ya usa esa página para recordar la selección entre
// recargas ('bundle-builder:items', ver assets/bundle-builder.js → persistState() /
// _restoreFromStorage()) — su propio código de restauración la recoge sola al cargar, no
// hace falta tocar esa página. Solo reconoce productos cuyo "handle" pertenezca a su propia
// colección, por eso la "Colección de productos recomendables" del quiz debe ser la misma.
(function () {
  if (customElements.get('quiz-recommender')) return;

  var KLAVIYO_WAIT_MS = 1200;

  class QuizRecommender extends HTMLElement {
    connectedCallback() {
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-quiz-step]'));
      this.photos = Array.prototype.slice.call(this.querySelectorAll('[data-quiz-photo]'));

      this.answers = {};
      this.answerLetters = {};
      this.history = [];
      this.isLoading = false;

      this.companyId = this.getAttribute('data-klaviyo-company-id') || '';
      this.listId = this.getAttribute('data-klaviyo-list-id') || '';
      this.metricName = this.getAttribute('data-klaviyo-metric') || 'Quiz Completado';
      this.invalidEmailMessage = this.getAttribute('data-invalid-email-message') || 'Introduce un email válido.';
      this.invalidPhoneMessage = this.getAttribute('data-invalid-phone-message') || 'Introduce un teléfono.';
      this.invalidConsentMessage = this.getAttribute('data-invalid-consent-message')
        || 'Debes completar todos los campos para ver la recomendación.';
      this.noResultsMessage = this.getAttribute('data-no-results-message')
        || 'Hemos guardado tus respuestas, pero no hay productos configurados para mostrar.';
      this.stepProgressTemplate = this.getAttribute('data-step-progress-template') || 'Paso {current} de {total}';
      this.progressAnnounce = this.querySelector('[data-quiz-progress-announce]');
      this.fallbackProductIds = this.parseIdList(this.getAttribute('data-fallback-product-ids'));
      this.bundleUrl = this.getAttribute('data-bundle-url') || '';
      this.noRecommendationMessage = this.getAttribute('data-no-recommendation-message') || '';
      this.noRecommendationPatterns = this.parsePatternList();
      this.combinations = this.parseCombinations();
      this.productMap = this.parseProductMap();

      this.popupMode = this.getAttribute('data-popup-mode') === 'true';

      // Pantalla de carga previa a la redirección (ver nota al principio del archivo). El
      // overlay y el texto se dejan en el HTML ya montados (ocultos con "hidden") para que
      // aparezcan en el mismo instante al enviar — si se crearan aquí, habría un frame
      // vacío entre la validación y el primer texto.
      this.loadingEnabled = this.getAttribute('data-loading-enabled') === 'true';
      this.loadingOverlay = this.querySelector('[data-quiz-loading]');
      this.loadingLayout = this.querySelector('[data-quiz-loading-layout]');
      this.loadingText = this.querySelector('[data-quiz-loading-text]');
      this.loadingStep1 = this.getAttribute('data-loading-step1-text') || '';
      this.loadingStep2 = this.getAttribute('data-loading-step2-text') || '';
      this.loadingStep1Ms = parseInt(this.getAttribute('data-loading-step1-ms'), 10) || 2000;
      this.loadingStep2Ms = parseInt(this.getAttribute('data-loading-step2-ms'), 10) || 2000;

      this.bindOptions();
      this.bindBack();
      this.bindEmailStep();
      this.bindIntroStart();

      if (this.steps.length) this.showStep(this.steps[0]);

      if (this.popupMode) this.initPopupTrigger();
    }

    // Modo popup: el quiz vive dentro de un <modal-dialog> (custom element ya existente en
    // el tema, ver assets/global.js) en vez de mostrarse siempre en la página. Aquí solo se
    // decide CUÁNDO abrirlo solo — el modal en sí (abrir/cerrar/overlay/foco/Escape) ya lo
    // gestiona ModalDialog, no hay que reimplementar nada de eso.
    initPopupTrigger() {
      var hideOnMobile = this.getAttribute('data-popup-hide-mobile') === 'true';
      if (hideOnMobile && window.matchMedia('(max-width: 749px)').matches) return;

      // A propósito, sin "solo una vez por sesión": se dispara siempre que pasen los
      // segundos configurados en esta página, cada vez que se cargue.
      var delaySeconds = parseInt(this.getAttribute('data-popup-delay'), 10) || 40;
      var modal = this.closest('modal-dialog');
      if (!modal) return;

      var self = this;
      setTimeout(function () {
        // Si ya está abierto (p. ej. lo abrió a mano el usuario, o el navegador restauró
        // la página desde bfcache con el modal ya abierto) no hace falta volver a abrirlo.
        if (modal.hasAttribute('open')) return;
        modal.show();
        // ModalDialog.show() ya atrapó el foco recorriendo todo el <quiz-recommender> (con
        // los pasos ocultos incluidos, ver comentario en showStep()) — se reacota aquí al
        // paso realmente visible en este momento.
        var activeStep = self.steps.filter(function (s) { return s.classList.contains('is-active'); })[0];
        if (activeStep && typeof trapFocus === 'function') {
          var focusTarget = activeStep.querySelector('h2, input, select, button');
          trapFocus(activeStep, focusTarget);
        }
      }, delaySeconds * 1000);
    }

    // El textarea "Combinaciones → productos" manda su texto tal cual dentro de un
    // <script type="application/json">, una línea por combinación:
    //   A,B,C,D,A:123456789:2,123456790:1,123456791:4
    // (letras de las respuestas, dos puntos, y luego ID:cantidad separados por coma — la
    // cantidad varía por combinación, no son siempre "3 productos"). Aquí se trocea a un
    // Map "A,B,C,D,A" -> [{id, qty}, ...].
    parseCombinations() {
      var map = {};
      var script = this.querySelector('[data-quiz-combinations]');
      if (!script) return map;

      var raw = '';
      try {
        raw = JSON.parse(script.textContent) || '';
      } catch (e) {
        return map;
      }

      raw.split('\n').forEach(function (line) {
        line = line.trim();
        if (!line) return;

        var separatorIndex = line.indexOf(':');
        if (separatorIndex === -1) return;

        // trim() por letra, no solo en los extremos — "A, B, C" (con espacio tras cada
        // coma, muy típico al pegar desde una celda de Excel/Sheets) nunca haría match
        // contra buildComboKey(), que siempre genera la clave sin espacios ("A,B,C").
        var key = line.slice(0, separatorIndex)
          .split(',')
          .map(function (part) { return part.trim(); })
          .join(',');
        var entries = line.slice(separatorIndex + 1);
        if (!key) return;

        map[key] = this.parseIdQtyList(entries);
      }, this);

      return map;
    }

    // "123456789:2,123456790:1" -> [{id:"123456789", qty:2}, {id:"123456790", qty:1}].
    // Si a algún trozo le falta la cantidad (formato antiguo, solo IDs), se asume 1.
    parseIdQtyList(value) {
      if (!value) return [];
      return value
        .split(',')
        .map(function (chunk) { return chunk.trim(); })
        .filter(function (chunk) { return chunk.length > 0; })
        .map(function (chunk) {
          var parts = chunk.split(':');
          var qty = parts.length > 1 ? parseInt(parts[1], 10) : 1;
          return { id: parts[0].trim(), qty: qty > 0 ? qty : 1 };
        });
    }

    parseIdList(value) {
      if (!value) return [];
      return value
        .split(',')
        .map(function (id) { return id.trim(); })
        .filter(function (id) { return id.length > 0; });
    }

    // "Combinaciones sin recomendación" — un patrón por línea, mismo orden de letras que la
    // clave de combinación, con "*" como comodín ("cualquier opción en esta pregunta"). Se
    // manda igual que el mapa de combinaciones (texto plano dentro de un <script>).
    parsePatternList() {
      var script = this.querySelector('[data-quiz-no-recommendation-patterns]');
      if (!script) return [];

      var raw = '';
      try {
        raw = JSON.parse(script.textContent) || '';
      } catch (e) {
        return [];
      }

      return raw.split('\n')
        .map(function (line) { return line.trim(); })
        .filter(function (line) { return line.length > 0; })
        .map(function (line) {
          return line.split(',').map(function (part) { return part.trim(); });
        });
    }

    // true si comboKey coincide con ALGUNO de los patrones (posición a posición, "*" vale
    // como cualquier letra en esa posición).
    matchesNoRecommendationPattern(comboKey) {
      var letters = comboKey.split(',');
      return this.noRecommendationPatterns.some(function (pattern) {
        if (pattern.length !== letters.length) return false;
        return pattern.every(function (part, i) {
          return part === '*' || part === letters[i];
        });
      });
    }

    // El script data-quiz-product-map manda "id:handle:variantId:price,id2:handle2:..." —
    // un producto por trozo separado por comas. Aquí se convierte en un Map
    // "id de producto" -> {handle, variantId, price}, para poder montar la preselección del
    // bundle a partir de los IDs que salgan de la combinación/reserva.
    parseProductMap() {
      var map = {};
      var script = this.querySelector('[data-quiz-product-map]');
      if (!script) return map;

      var raw = '';
      try {
        raw = JSON.parse(script.textContent) || '';
      } catch (e) {
        return map;
      }

      raw.split(',').forEach(function (chunk) {
        var parts = chunk.split(':');
        if (parts.length < 4) return;
        var id = parts[0].trim();
        if (!id) return;
        map[id] = { handle: parts[1], variantId: Number(parts[2]), price: Number(parts[3]) || 0 };
      });

      return map;
    }

    bindOptions() {
      var self = this;

      this.querySelectorAll('[data-quiz-option]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = button.closest('[data-quiz-step]');
          var siblings = Array.prototype.slice.call(step.querySelectorAll('[data-quiz-option]'));
          var letter = self.indexToLetter(siblings.indexOf(button) + 1);
          self.selectOption(step, button.getAttribute('data-value'), letter);
          self.advance(step);
        });
      });

      this.querySelectorAll('[data-quiz-input]').forEach(function (select) {
        select.addEventListener('change', function () {
          var step = select.closest('[data-quiz-step]');
          var option = select.options[select.selectedIndex];
          // La 1ª opción real del <select> es índice nativo 1 (el 0 es el placeholder
          // "Elige una opción" deshabilitado) — coincide justo con "1ª opción = A".
          var letter = self.indexToLetter(option.index);
          self.selectOption(step, option.value, letter);
          self.advance(step);
        });
      });
    }

    indexToLetter(oneBasedIndex) {
      return String.fromCharCode(64 + oneBasedIndex);
    }

    bindBack() {
      var self = this;
      this.querySelectorAll('[data-quiz-back]').forEach(function (button) {
        button.addEventListener('click', function () {
          self.goBack();
        });
      });
    }

    // Botón "Empezar test" de la pantalla inicial del popup (ver sections/quiz-recommender.liquid)
    // — reutiliza el mismo advance() genérico que usan los botones de opción de cualquier
    // pregunta, así que no hace falta ninguna lógica de navegación nueva.
    bindIntroStart() {
      var self = this;
      this.querySelectorAll('[data-quiz-start]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = button.closest('[data-quiz-step]');
          self.advance(step);
        });
      });
    }

    bindEmailStep() {
      var self = this;
      var submitButton = this.querySelector('[data-quiz-submit]');
      if (submitButton) {
        submitButton.addEventListener('click', function () {
          self.submit();
        });
      }
    }

    selectOption(step, value, letter) {
      var property = step.getAttribute('data-klaviyo-property');
      if (property) {
        this.answers[property] = value;
        this.answerLetters[property] = letter;
      }

      step.querySelectorAll('[data-quiz-option]').forEach(function (button) {
        button.classList.toggle('is-selected', button.getAttribute('data-value') === value);
      });
    }

    // Una pregunta es condicional si lleva data-show-if-property: solo cuenta como
    // "visible" cuando la respuesta ya guardada para esa propiedad coincide exactamente
    // con data-show-if-value. Sin esos atributos, siempre es visible. No hay ningún caso
    // especial cableado a mano: cualquier pregunta puede depender de cualquier otra.
    isStepVisible(step) {
      var property = step.getAttribute('data-show-if-property');
      if (!property) return true;
      return this.answers[property] === step.getAttribute('data-show-if-value');
    }

    advance(currentStep) {
      this.history.push(currentStep);

      var currentIndex = this.steps.indexOf(currentStep);
      var next = null;
      for (var i = currentIndex + 1; i < this.steps.length; i++) {
        if (this.isStepVisible(this.steps[i])) {
          next = this.steps[i];
          break;
        }
      }

      // Sin paso siguiente: normalmente el paso de email es siempre el último, así que esto
      // solo pasa cuando ese paso está apagado (ajuste "Pedir email y teléfono...") — en vez
      // de quedarse parado tras la última pregunta, se envía directo, igual que si se hubiera
      // pulsado el botón "Ver mi recomendación" del paso de email.
      if (next) {
        this.showStep(next);
      } else {
        this.submit();
      }
    }

    goBack() {
      var previous = this.history.pop();
      if (previous) this.showStep(previous);
    }

    showStep(step) {
      this.steps.forEach(function (s) {
        s.classList.toggle('is-active', s === step);
      });

      this.updatePhoto(step);
      this.updateProgress(step);

      var focusTarget = step.querySelector('h2, input, select, button');
      if (focusTarget) focusTarget.focus({ preventScroll: true });

      // En modo popup, ModalDialog.show() (assets/global.js) atrapa el foco recorriendo
      // TODO el <quiz-recommender> de una sola vez, incluidos los pasos que están ocultos
      // con display:none (todos menos el activo) — como esos nunca son alcanzables de
      // verdad con Tab, el "last" que calcula queda mal y el trap deja de hacer wrap-around
      // al llegar al final. Se reacota aquí, en cada cambio de paso, solo al paso que
      // realmente está visible — mismo trapFocus() que ya usa el resto del tema (global.js,
      // usado tal cual también por cart-drawer.js, cart.js, details-modal.js...).
      if (this.popupMode && typeof trapFocus === 'function') {
        var modal = this.closest('modal-dialog');
        if (modal && modal.hasAttribute('open')) trapFocus(step, focusTarget);
      }
    }

    updatePhoto(step) {
      var target = step.getAttribute('data-photo-target');

      var hasTargetPhoto = !!target && this.photos.some(function (img) {
        return img.getAttribute('data-quiz-photo') === target;
      });
      var hasDefaultPhoto = this.photos.some(function (img) {
        return img.getAttribute('data-quiz-photo') === 'default';
      });

      // Un paso sin foto propia (ej. el paso de email) y sin foto por defecto configurada
      // no tiene nada que mostrar — se deja la última foto activa en vez de dejar el panel
      // en blanco.
      var activeKey = hasTargetPhoto ? target : (hasDefaultPhoto ? 'default' : null);
      if (!activeKey) return;

      this.photos.forEach(function (img) {
        var isActive = img.getAttribute('data-quiz-photo') === activeKey;
        if (isActive) this.loadPhoto(img);
        img.classList.toggle('is-active', isActive);
      }, this);
    }

    loadPhoto(img) {
      // La foto del primer paso ya viene con src/srcset reales desde Liquid (es la única
      // visible al llegar a la página); el resto se guarda en data-src/data-srcset y se
      // asigna aquí, justo cuando esa pregunta pasa a estar activa, para no descargar de
      // golpe todas las fotos del quiz.
      var src = img.getAttribute('data-src');
      if (!src) return;

      img.src = src;
      var srcset = img.getAttribute('data-srcset');
      if (srcset) img.srcset = srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    updateProgress(step) {
      if (!this.progressAnnounce) return;
      // Aproximado: cuenta los pasos que son visibles ahora mismo (según las respuestas ya
      // dadas), más el actual. Si una pregunta condicional más adelante depende de una
      // respuesta que el usuario aún no ha dado, no cuenta todavía — el anuncio se
      // reajusta solo en cuanto se responde la pregunta de la que depende.
      var total = this.steps.filter(function (s) {
        return s === step || this.isStepVisible(s);
      }, this).length;

      var doneSteps = this.history.length + 1;

      this.progressAnnounce.textContent = this.stepProgressTemplate
        .replace('{current}', doneSteps)
        .replace('{total}', total);
    }

    // Junta la letra de cada pregunta que de verdad se mostró, en el mismo orden en que
    // aparecen las preguntas en la sección. Se recalcula entera aquí (no se va acumulando
    // mientras se avanza) para que quede bien aunque el usuario vaya para atrás y cambie
    // una respuesta a mitad de camino.
    buildComboKey() {
      var letters = [];

      this.steps.forEach(function (step) {
        if (!this.isStepVisible(step)) return;
        if (step.hasAttribute('data-exclude-from-combo')) return;
        var property = step.getAttribute('data-klaviyo-property');
        var letter = property ? this.answerLetters[property] : null;
        if (letter) letters.push(letter);
      }, this);

      return letters.join(',');
    }

    // Tiempo total que la pantalla de carga se queda delante como MÍNIMO: el primer texto
    // (mientras se "calcula" la recomendación) y luego el segundo (mientras se añaden los
    // productos al carrito). Con la pantalla apagada o sin overlay en el HTML, 0.
    loadingTotalMs() {
      if (!this.loadingEnabled || !this.loadingOverlay) return 0;
      return this.loadingStep1Ms + this.loadingStep2Ms;
    }

    showLoadingScreen() {
      this.isLoading = true;

      if (!this.loadingEnabled || !this.loadingOverlay) return;

      if (this.loadingText) this.loadingText.textContent = this.loadingStep1;
      this.loadingOverlay.removeAttribute('hidden');

      // "inert" (y no solo taparlo con el overlay) para que el teclado no pueda seguir
      // moviéndose por los campos del paso de email que hay detrás: el botón ya queda con
      // pointer-events:none por [aria-busy], pero con el Tab se llegarían igual. Los navegadores
      // sin soporte para "inert" simplemente lo ignoran — el overlay los tapa igualmente.
      if (this.loadingLayout && 'inert' in this.loadingLayout) this.loadingLayout.inert = true;

      var self = this;
      this.loadingStepTimer = setTimeout(function () {
        if (self.loadingText) self.loadingText.textContent = self.loadingStep2;
      }, this.loadingStep1Ms);
    }

    hideLoadingScreen() {
      this.isLoading = false;

      if (this.loadingStepTimer) {
        clearTimeout(this.loadingStepTimer);
        this.loadingStepTimer = null;
      }

      if (this.loadingOverlay) this.loadingOverlay.setAttribute('hidden', '');
      if (this.loadingLayout && 'inert' in this.loadingLayout) this.loadingLayout.inert = false;
    }

    submit() {
      // Doble clic (o Enter a la vez) en el botón: el segundo intento no debe volver a
      // mandar el evento ni redirigir otra vez por delante.
      if (this.isLoading) return;

      // Los 3 pueden no existir: el ajuste "Pedir email y teléfono..." apaga ese paso entero
      // (petición temporal del cliente) — en ese caso se salta toda esta validación y se
      // calcula/redirige directo, sin email/teléfono/consentimiento/Klaviyo/tag de cliente.
      var emailField = this.querySelector('#QuizEmail');
      var phoneField = this.querySelector('#QuizPhone');
      var consentField = this.querySelector('#QuizConsent');
      var errorBox = this.querySelector('[data-quiz-error]');
      var submitButton = this.querySelector('[data-quiz-submit]');

      if (emailField && !emailField.checkValidity()) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = this.invalidEmailMessage;
        }
        emailField.focus();
        return;
      }

      if (phoneField && !phoneField.checkValidity()) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = this.invalidPhoneMessage;
        }
        phoneField.focus();
        return;
      }

      if (consentField && !consentField.checked) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = this.invalidConsentMessage;
        }
        consentField.focus();
        return;
      }

      if (errorBox) errorBox.hidden = true;
      if (submitButton) submitButton.setAttribute('aria-busy', 'true');

      var email = emailField ? emailField.value.trim() : '';
      // Mismo criterio que assets/callme-popup.js: prefijo + solo dígitos del número.
      var phonePrefixField = this.querySelector('#QuizPhonePrefix');
      var phonePrefix = phonePrefixField ? phonePrefixField.value : '';
      var phoneDigits = phoneField ? phoneField.value.replace(/[^\d]/g, '') : '';
      var phone = phoneDigits ? phonePrefix + phoneDigits : '';
      var consent = !!(consentField && consentField.checked);
      var comboKey = this.buildComboKey();

      if (this.matchesNoRecommendationPattern(comboKey)) {
        // Casos en los que el equipo de nutrición ya decidió que ningún plato del catálogo
        // encaja (ej. textura "come como nosotros") — no tiene sentido mandar productos de
        // reserva random ni redirigir al bundle. Se guarda igualmente el lead en Klaviyo (las
        // respuestas siguen siendo información útil), pero se avisa en la propia página en
        // vez de redirigir.
        if (email) {
          this.sendEvent(email, phone, comboKey, []);
          if (consent && this.listId) this.subscribe(email, phone);
        }
        if (submitButton) submitButton.removeAttribute('aria-busy');
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = this.noRecommendationMessage || this.noResultsMessage;
        }
        return;
      }

      // this.combinations ya trae [{id, qty}, ...] por línea; el fallback es una simple
      // lista de IDs (this.fallbackProductIds), así que se normaliza aquí a la misma forma
      // (cantidad 1 cada uno) para tratarlos igual de aquí en adelante.
      var recommendedEntries = this.combinations[comboKey] || this.fallbackProductIds.map(function (id) {
        return { id: id, qty: 1 };
      });
      var self = this;

      // Se resuelven los items ANTES de decidir si hay algo a lo que redirigir — si ninguno
      // de los IDs recomendados (ni de la combinación ni de la reserva) está en la colección
      // del quiz, no tiene sentido mandar a alguien a un bundle vacío y sin explicación.
      // Una entrada por UNIDAD (no una entrada con quantity:N) — es el mismo criterio que ya
      // usa esa página al leer su carrito real (ver _resyncFromCart en bundle-builder.js),
      // así que el resultado se comporta exactamente igual que si se hubiera ido añadiendo
      // a mano N veces.
      // El orden de "recommendedEntries" es el de las columnas del Excel, no el de la PLP —
      // por eso primero se pasa a un mapa id->cantidad, y luego se recorre this.productMap
      // (que sigue el mismo orden que la colección/PLP, ver parseProductMap) para que los
      // platos entren al carrito del bundle en el mismo orden en que se ven en la PLP.
      var recommendedQty = {};
      recommendedEntries.forEach(function (rec) {
        recommendedQty[rec.id] = (recommendedQty[rec.id] || 0) + rec.qty;
      });

      var items = [];
      Object.keys(this.productMap).forEach(function (id) {
        var qty = recommendedQty[id];
        if (!qty) return;
        var product = self.productMap[id];
        for (var i = 0; i < qty; i++) {
          items.push({ handle: product.handle, variantId: product.variantId, price: product.price, quantity: 1 });
        }
      });

      if (!this.bundleUrl || !items.length) {
        // Sin URL de destino configurada, o sin ningún producto que preseleccionar: no
        // tiene sentido redirigir. Avisamos en vez de dejar el botón "cargando" para
        // siempre sin explicación, o mandar a un bundle vacío sin decir nada — ambos son
        // casos de configuración a arreglar en el editor, no algo que le pase al usuario
        // normal con la combinaciones bien rellenadas.
        if (submitButton) submitButton.removeAttribute('aria-busy');
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = this.noResultsMessage;
        }
        return;
      }

      var eventSent = email ? this.sendEvent(email, phone, comboKey, recommendedEntries) : Promise.resolve();
      if (email && consent && this.listId) this.subscribe(email, phone);

      // Pantalla de carga: sale justo antes de esperar a Klaviyo, así que el overlay aparece
      // en el mismo instante en que se envía el formulario (nada de un salto de "vacío" entre
      // el paso de email y la primera línea de texto).
      this.showLoadingScreen();

      // OJO: no se llama a hideLoadingScreen() aquí. Si se quita el overlay antes de
      // redirigir, el quiz queda al descubierto durante el instante que tarda el navegador
      // en pintar la navegación real — exactamente el "parpadeo" que no queremos. Como de
      // todas formas se abandona la página, el overlay se queda puesto hasta el final.
      var finish = function () {
        self.redirectToBundle(items);
      };

      var klaviyoTimeout = new Promise(function (resolve) {
        setTimeout(resolve, KLAVIYO_WAIT_MS);
      });

      var loadingTime = new Promise(function (resolve) {
        setTimeout(resolve, self.loadingTotalMs());
      });

      // Las dos cosas a la vez: Klaviyo (con su tope de siempre) y el tiempo de la pantalla.
      // Promise.all solo falla si alguna de las dos promesas revienta, y finish va también
      // en el catch para no dejar al usuario mirando la pantalla de carga para siempre.
      Promise.all([Promise.race([eventSent, klaviyoTimeout]), loadingTime])
        .then(finish)
        .catch(finish);
    }

    // Preselecciona los productos recomendados en la página del bundle y redirige ahí —
    // ver la nota al principio del archivo sobre el mecanismo de localStorage compartido.
    //
    // El form nativo de Shopify (creado en el paso de email) sigue siendo el que crea/
    // etiqueta el Customer (contact[tags]), pero se manda por fetch en vez de con un envío
    // real del formulario: un envío real navega de verdad (el propio "ir y volver" de
    // Shopify), y aunque "return_to" apunte al bundle, de camino se ve un parpadeo de esta
    // misma página recargándose antes de llegar ahí. Por fetch, el Customer se crea igual
    // en el servidor pero la redirección la hace este JS al instante, sin ese parpadeo.
    redirectToBundle(items) {
      try {
        localStorage.setItem('bundle-builder:items', JSON.stringify({
          items: items,
          purchaseType: 'subscription',
          sellingPlanId: null
        }));
      } catch (e) {
        // Silencioso (localStorage puede fallar en navegación privada) — igualmente se
        // redirige, solo que sin preselección; mejor eso que quedarse atascado aquí.
      }

      var customerForm = this.querySelector('.quiz__customer-form');
      if (customerForm) {
        try {
          fetch(customerForm.action, {
            method: 'POST',
            body: new FormData(customerForm),
            keepalive: true
          });
        } catch (e) {
          // Silencioso: si el navegador no puede mandarlo (ej. sin fetch), no bloquea
          // la redirección — mejor llegar al plan sin el tag del customer que no llegar.
        }
      }

      window.location.href = this.bundleUrl;
    }

    sendEvent(email, phone, comboKey, recommendedEntries) {
      if (!this.companyId) return Promise.resolve();

      var properties = Object.assign({}, this.answers, {
        combinacion: comboKey,
        productos_recomendados: recommendedEntries
          .map(function (rec) { return rec.id + ':' + rec.qty; })
          .join(',')
      });
      if (phone) properties.telefono = phone;

      var profileAttributes = { email: email };
      if (phone) profileAttributes.phone_number = phone;

      var body = {
        data: {
          type: 'event',
          attributes: {
            properties: properties,
            metric: {
              data: {
                type: 'metric',
                attributes: { name: this.metricName }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          }
        }
      };

      return fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(this.companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2025-07-15'
        },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(function () {
        // Silencioso: si Klaviyo falla, no debe bloquear que se vea el resultado.
      });
    }

    subscribe(email, phone) {
      var profileAttributes = {
        email: email,
        subscriptions: {
          email: { marketing: { consent: 'SUBSCRIBED' } }
        }
      };
      if (phone) profileAttributes.phone_number = phone;

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Quiz recomendador',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: this.listId } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2025-07-15'
        },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(function () {
        // Silencioso: la suscripción es secundaria al evento con las respuestas.
      });
    }
  }

  customElements.define('quiz-recommender', QuizRecommender);
})();
